import { __awaiter, __generator } from "tslib";
import { BubbleCommand } from '../../../_shared/constants';
import { _inactivate } from '../../../client/src/_library/utils/thread-heartbeat';
import { BubbleChannel } from '../../../client/src/modules/_core/components/BubbleChannel';
import { url } from '../../../client/src/modules/_core/url';
import { deleteFromSessionStorage, getClientConfig, getSessionThreadId, removeSessionThreadId, } from '../../../client/src/modules/_core/utils/app-storage';
import { confirmModal } from '../../../client/src/modules/domain/app-modal';
import { dataLayerPush, getRandomInt } from '../../utils';
export var headerOnCloseHandler = function (cmp, toggleStaffino, force) {
    if (force === void 0) { force = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var STAFFINO_SHOW_PERCENTAGE, staffInfoShowPercentage, staffinoShowPercentage, dispatch, confirmClose, endOrClose, randomNumber, messages, anyMessageFromUser;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    STAFFINO_SHOW_PERCENTAGE = getClientConfig().STAFFINO_SHOW_PERCENTAGE;
                    staffInfoShowPercentage = cmp.props.staffInfoShowPercentage;
                    staffinoShowPercentage = typeof staffInfoShowPercentage === 'number' &&
                        Number.isFinite(staffInfoShowPercentage)
                        ? staffInfoShowPercentage
                        : STAFFINO_SHOW_PERCENTAGE;
                    dispatch = cmp.props.dispatch;
                    confirmClose = function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, confirmModal(dispatch, {
                                    title: 'Opravdu si přejete chat ukončit?',
                                    labelOK: 'Ukončit',
                                    labelCancel: 'Zpět',
                                })];
                        });
                    }); };
                    endOrClose = function () {
                        // https://docs.google.com/spreadsheets/d/1WDsoIs_v0Dc1sOASo0k0ugUbb2i7o3QaJj6NyZisKAQ/edit#gid=0
                        dataLayerPush({ eventAction: 'UpperCornerClick', eventLabel: 'Close' });
                        _inactivate(getSessionThreadId(), { event: 'CLOSED_MANUALLY_BY_USER' });
                        removeSessionThreadId();
                        deleteFromSessionStorage('variantId');
                        cmp.props.history.push(url.HOME());
                        BubbleChannel.postCommand(BubbleCommand.CLOSE);
                    };
                    if (force)
                        return [2 /*return*/, endOrClose()];
                    return [4 /*yield*/, confirmClose()];
                case 1:
                    if (_a.sent()) {
                        randomNumber = getRandomInt(0, 100);
                        console.log('Staffino show probability', randomNumber, staffinoShowPercentage);
                        messages = cmp.props.getThreadMessages(cmp.props.threadId);
                        anyMessageFromUser = messages.some(function (_a) {
                            var is_bot = _a.is_bot;
                            return !is_bot;
                        });
                        if (anyMessageFromUser &&
                            staffinoShowPercentage !== 0 &&
                            randomNumber <= staffinoShowPercentage) {
                            _inactivate(getSessionThreadId(), { event: 'CLOSED_MANUALLY_BY_USER' });
                            return [2 /*return*/, toggleStaffino()];
                        }
                        endOrClose();
                    }
                    return [2 /*return*/];
            }
        });
    });
};
